import React from "react";
import { PageConfig } from "../../models";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, InputLabel, MenuItem, Select, SelectChangeEvent, Switch, TextField } from "@mui/material";

interface PersonaPageConfigFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pageConfig: PageConfig;
  onPageConfigChange: (pageConfig: PageConfig) => void;
}

export const PersonaPageConfigFormDialog: React.FC<PersonaPageConfigFormDialogProps> = ({ open, onOpenChange, pageConfig, onPageConfigChange }) => {
  function handlePageConfigChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<unknown>) {
    const field = event.target.name;

    if (["midRollStartSeconds"].includes(field)) {
      if (parseInt(event.target.value as string) < 0) {
        event.target.value = 0;
      }
    }

    onPageConfigChange({ ...pageConfig, [field]: event.target.value });
  }

  function handleSwitchChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    const field = event.target.name;
    onPageConfigChange({ ...pageConfig, [field]: checked });
  }

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      PaperProps={{
        style: {
          backgroundColor: '#03bfcb',
        },
      }}
      open={open}
      onClose={() => onOpenChange(false)}
    >
      <DialogTitle>Page Config</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.randomContentOrder}
              onChange={handleSwitchChange}
              name="randomContentOrder"
              color="primary"
            />
          }
          label="Random Content Order"
        />

        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.randomStimOrder}
              onChange={handleSwitchChange}
              name="randomStimOrder"
              color="primary"
            />
          }
          label="Random Stim Order"
        />

        <FormControl className="spacer" variant="outlined">
          <InputLabel>Type</InputLabel>
          <Select
            value={pageConfig.feedPage}
            onChange={handlePageConfigChange}
            label="Feed Page"
            name="feedPage"
          >
            <MenuItem value={"feed"}>Feed</MenuItem>
            <MenuItem value={"watch"}>Watch</MenuItem>
            <MenuItem value={"reel"}>Reel</MenuItem>
          </Select>
        </FormControl>

        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.forceFeed}
              onChange={handleSwitchChange}
              name="forceFeed"
              color="primary"
            />
          }
          label="Force Feed"
        />

        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.skippableStims}
              onChange={handleSwitchChange}
              name="skippableStims"
              color="primary"
            />
          }
          label="Skippable Stims"
        />

        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.adViewOnCompletion}
              onChange={handleSwitchChange}
              name="adViewOnCompletion"
              color="primary"
            />
          }
          label="Ad View On Completion"
        />

        <TextField
          inputProps={{ min: 0, type: "number" }}
          variant="outlined"
          label="Midroll Start Seconds"
          name="midRollStartSeconds"
          value={pageConfig.midRollStartSeconds}
          onChange={handlePageConfigChange}
        />

        <FormControlLabel className="spacer"
          control={
            <Switch
              checked={pageConfig.nextVideoAutoplay}
              onChange={handleSwitchChange}
              name="nextVideoAutoplay"
              color="primary"
            />
          }
          label="Next Video Autoplay"
        />

        <FormControl className="spacer" variant="outlined">
          <InputLabel>Video Ads Play Type</InputLabel>
          <Select
            value={pageConfig.videoAdsPlayType}
            onChange={handlePageConfigChange}
            label="Video Ads Play Type"
            name="videoAdsPlayType"
          >
            <MenuItem value={"all"}>All</MenuItem>
            <MenuItem value={"all_random"}>All Random</MenuItem>
            <MenuItem value={"one"}>One</MenuItem>
            <MenuItem value={"one_of_each"}>One of Each</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => onOpenChange(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  )
};